// export const API_BASE_URL = process.env.REACT_APP_API_URL;
// export const AI_DOMAIN_URL = process.env.REACT_APP_AI_DOMAIN;
// export const LOGO_URL = process.env.REACT_APP_LOGO_URL;
// export const APP_NAME = process.env.REACT_APP_PROJECT_NAME;
// export const STRIP_PUBLISHABLE_KEY = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY;
// export const STRIP_SECRET_KEY = process.env.REACT_APP_STRIP_SECRET_KEY;
// export const PAYPAL_CLIENT_ID = process.env.REACT_APP_PAYPAL_CLIENT_ID || '';

export const RECAPTCHA_SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY || '';
export const RECAPTCHA_SECRET_KEY = process.env.REACT_APP_RECAPTCHA_SECRET_KEY;  